(() => {
  const within = (scope, selector) => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function hydrate(scope = document) {
    const catalog = document.querySelector('[data-carls-catalog]');
    if (!catalog) return;
    const menuSource = catalog.querySelector('[data-catalog-template="c9"]');
    const availableCards = menuSource ? [...menuSource.content.querySelectorAll('article[data-variant-id]')] : [];
    const uniqueCards = [...new Map(availableCards.filter(card => card.dataset.variantId).map(card => [card.dataset.variantId, card])).values()];
    within(scope, '[data-category-slot]').forEach(slot => {
      if (slot.dataset.categoriesLoaded) return;
      const source = catalog.querySelector(`[data-category-template="${slot.dataset.categorySlot}"]`);
      if (!source) return;
      const fragment = source.content.cloneNode(true), seen = new Set();
      fragment.querySelectorAll('button').forEach(button => {
        const key = button.dataset.filter || button.dataset.menuFilter;
        const count = uniqueCards.filter(card => key === 'all' || card.dataset.menuMeat === key).length;
        if (!button.textContent.trim() || seen.has(key) || (key !== 'all' && !count && button.dataset.hideEmpty !== 'false')) { button.remove(); return; }
        seen.add(key);
        const counter = button.querySelector('[data-category-count]');
        if (counter) counter.textContent = count;
      });
      slot.replaceChildren(fragment); slot.dataset.categoriesLoaded = 'true';
    });
    within(scope, '[data-catalog-slot]').forEach(slot => {
      const source = catalog.querySelector(`[data-catalog-template="${slot.dataset.catalogSlot}"]`);
      if (!source || slot.dataset.catalogLoaded) return;
      const fragment = source.content.cloneNode(true), seen = new Set();
      fragment.querySelectorAll('article[data-variant-id]').forEach(card => {
        const id = card.dataset.variantId;
        if (!id || seen.has(id)) { fragment.querySelector(`[id="detail-${card.dataset.id}"]`)?.remove(); card.remove(); }
        else seen.add(id);
      });
      slot.replaceChildren(fragment); slot.dataset.catalogLoaded = 'true';
    });
    document.querySelectorAll('[data-catalog-count]').forEach(el => el.textContent = uniqueCards.length);
  }
  function refresh() {
    document.querySelectorAll('[data-builder]').forEach(root => {
      root.carlsBuilderDestroy?.(); root.carlsFunnelDestroy?.();
      delete root.dataset.initialised; delete root.dataset.funnelInitialised;
    });
    document.querySelectorAll('[data-catalog-slot]').forEach(slot => delete slot.dataset.catalogLoaded);
    document.querySelectorAll('[data-category-slot]').forEach(slot => delete slot.dataset.categoriesLoaded);
    document.querySelectorAll('[data-c9-menu]').forEach(root => {
      delete root.dataset.ready;
      root.querySelectorAll('[data-menu-expand]').forEach(el => el.replaceWith(el.cloneNode(true)));
    });
    hydrate(); document.dispatchEvent(new CustomEvent('carls:catalog-ready'));
  }
  window.CarlsCatalog = { hydrate };
  hydrate();
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('[data-carls-catalog]')) refresh();
    else hydrate(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-builder]').forEach(root => { root.carlsBuilderDestroy?.(); root.carlsFunnelDestroy?.(); });
  });
  document.addEventListener('shopify:section:select', event => {
    if (event.target.querySelector('[data-builder]')) document.querySelector('a[href="#hugos-survey"]')?.click();
  });
  document.addEventListener('shopify:block:select', event => {
    const id = event.detail?.blockId;
    if (!id) return;
    const item = [...document.querySelectorAll('[data-shopify-editor-block]')].find(el => {
      if (!el.getClientRects().length && !el.closest('[data-c9-menu]')?.getClientRects().length) return false;
      try { return JSON.parse(el.dataset.shopifyEditorBlock).id === id; } catch { return false; }
    });
    if (item) { const menu = item.closest('[data-c9-menu]'); if (menu && item.hidden) { menu.querySelector('[data-menu-filter="all"]')?.click(); const expand = menu.querySelector('[data-menu-expand]'); if (expand?.getAttribute('aria-expanded') !== 'true') expand?.click(); } item.hidden = false; item.scrollIntoView({ block: 'center', behavior: 'instant' }); }
  });
})();
